import React from 'react'

const PlannerDetailsId = (props) => {
    console.log(props)
  return (
    <div>Detalles de envio [editar Posición] </div>
  )
}

export default PlannerDetailsId